var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"is-grey mb-2 previous_link",attrs:{"to":{ path: _vm.path },"event":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.beforeClick({ path: _vm.path })}}},[_c('i',{staticClass:"mdi mdi-chevron-left"}),_vm._v("\n\n  "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }